import React from "react";
import { Box } from "@mui/material";

function Underline({ color = "#ffffff" }) {
	return (
		<Box
			className="underline"
			sx={(theme) => ({
				display: "block",
				maxWidth: theme.spacing(7),
				height: theme.spacing(0.5),
				backgroundColor: color,
				borderRadius: theme.spacing(1),
				marginTop: theme.spacing(1),
			})}
		></Box>
	);
}

export default Underline;
